import { styled } from '@mui/material';
import { colors } from '@styles/colors';

interface PageProps {
  children: React.ReactNode;
}

export function CenteredPage({ children }: PageProps) {
  return (
    <Page>
      <Form>{children}</Form>
    </Page>
  );
}

const Page = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.mode === 'light' ? colors.foreground : colors.black,
}));

const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  width: '100%',
  color: theme.palette.text.primary,
  maxWidth: '340px',
  [theme.breakpoints.up('md')]: {
    maxWidth: '380px',
  },

  [theme.breakpoints.up('lg')]: {
    maxWidth: '400px',
  },
}));
